// @flow
import $ from 'jquery';
import JQueryView, { on } from './JQueryView';

export default class SimpleFormView extends JQueryView {
  constructor() {
    super('.simple_form');
  }

  @on({ event: 'input', selector: '.positive-integer' })
  acceptOnlyPositiveInteger(e: any) {
    const target = $(e.target);
    target.val(target.val().replace(/[^0-9]/g, ''));
  }
}
